<div class="layout-col full gap-sm pt-sm">
  @if (showEvalElements) {
    <ng-template elderToolbarColumn="right.actions">
      <app-facility-context-menu></app-facility-context-menu>
    </ng-template>
  }

  <div class="layout-col full gap-sm" appFacilityContext (facilityChange)="facility = $event">
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [showFooterRow]="true"
      [selectionMultiEnabled]="true"
      [(selection)]="selection"
      [selectionVisible]="true"
      (selectionChange)="calculateTotals($event)"
    >
      <elder-data-toolbar *elderTableToolbar [canAdd]="false" [canRemove]="false" [canMore]="false">
        <ng-template elderToolbarContent="left">
          <div class="flex layout-row place-center-center gap-xl p-xl">
            @if (showEvalElements) {
              <mat-form-field elderDense elderIntervalPickerBinding>
                <mat-label>{{ 'interval.to-exclusive' | translate }}</mat-label>
                <elder-interval-input [mode]="'date-range'" [(ngModel)]="completionInterval">
                </elder-interval-input>
                <elder-interval-picker-toggle matIconSuffix></elder-interval-picker-toggle>
              </mat-form-field>
            }

            @if (showEvalElements) {
              <mat-checkbox name="GroupByDay" [(ngModel)]="isByDayVariant">
                {{ 'reports.groupByDay' | translate }}
              </mat-checkbox>
            }
          </div>
        </ng-template>

        <ng-template elderToolbarContent="center">
          <div class="layout-row full place-between-center gap-xl">
            <mat-form-field elderNoHint elderDense class="flex-30 py-sm">
              <mat-label>{{ 'shopfloor.workcenters.title' | translate }}</mat-label>
              <elder-multi-select-chips
                [dataSource]="workCenterService"
                displayProperty="name"
                [filters]="facilitySuggestion(facilityId)"
                [(value)]="workCenters"
              >
                <app-work-center-browser
                  *elderSelectionModelPopup
                  class="flex"
                  [facility]="facilityId"
                ></app-work-center-browser>
                <mat-icon *elderSelectChipAvatar="let chipModel">work</mat-icon>
              </elder-multi-select-chips>
            </mat-form-field>
            <elder-chip-list-select
              [data]="involvedProcessPlans$ | async"
              [idField]="'id'"
              [displayField]="'name'"
              [selectionMultiEnabled]="true"
              (selectionChange)="changeProcessPlans($event)"
            >
            </elder-chip-list-select>
          </div>
        </ng-template>
      </elder-data-toolbar>

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 40px"></th>
        <td mat-cell *matCellDef="let record">
          <mat-icon>work</mat-icon>
        </td>
        <td *matFooterCellDef mat-footer-cell>{{ 'context.total' | translate }}</td>
      </ng-container>

      @if ((evalVariant$ | async) === EvalVariant.BYDAY) {
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="date" style="width: 100px">
            {{ 'context.date' | translate }}
          </th>
          <td mat-cell *matCellDef="let record">
            <span>{{ record?.date }}</span>
          </td>
          <td *matFooterCellDef mat-footer-cell></td>
        </ng-container>
      }

      <ng-container matColumnDef="workCenterNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="workCenterNumber" style="width: 5%">
          {{ 'context.number' | translate }}
        </th>
        <td mat-cell *matCellDef="let record">
          {{ record?.workCenterNumber }}
        </td>
        <td *matFooterCellDef mat-footer-cell></td>
      </ng-container>

      <ng-container matColumnDef="workCenterName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="workCenterName" style="width: 20%">
          {{ 'shopfloor.workcenters.workcenter' | translate }}
        </th>
        <td mat-cell *matCellDef="let record">
          {{ record?.workCenterName }}
        </td>
        <td *matFooterCellDef mat-footer-cell></td>
      </ng-container>

      <ng-container matColumnDef="totalProducedProduct">
        <th mat-header-cell *matHeaderCellDef elderNumberCell style="width: 10%">
          {{ 'reports.pieceQuantity' | translate }}
        </th>
        <td mat-cell *matCellDef="let record" elderNumberCell>
          <span>{{ round(record?.totalProducedProduct) }}</span>
        </td>
        <td mat-footer-cell elderNumberCell *matFooterCellDef>{{ round(totalPieceQuantity) }}</td>
      </ng-container>

      <ng-container matColumnDef="totalItems">
        <th mat-header-cell *matHeaderCellDef elderNumberCell style="width: 10%">
          {{ 'reports.itemQuantity' | translate }}
        </th>
        <td mat-cell *matCellDef="let record" elderNumberCell>
          <span>{{ record?.totalItems }}</span>
        </td>
        <td mat-footer-cell elderNumberCell *matFooterCellDef>{{ totalItemQuantity }}</td>
      </ng-container>

      <ng-container matColumnDef="totalWeight">
        <th mat-header-cell *matHeaderCellDef elderNumberCell style="width: 10%">
          {{ 'context.totalWeight' | translate }}
        </th>
        <td mat-cell *matCellDef="let record" elderNumberCell>
          <span>{{ record?.totalWeight | elderQuantity: true : null : '1.0-0' }}</span>
        </td>
        <td mat-footer-cell elderNumberCell *matFooterCellDef>
          {{ totalWeight | elderQuantity: true : null : '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="manufactureFacility">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="manufactureFacility"
          style="width: 60px"
        >
          {{ 'context.facility' | translate }}
        </th>
        <td mat-cell *matCellDef="let record">
          {{ record?.manufactureFacility }}
        </td>
        <td *matFooterCellDef mat-footer-cell></td>
      </ng-container>

      <ng-container matColumnDef="spacer">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let record"></td>
        <td *matFooterCellDef mat-footer-cell></td>
      </ng-container>
    </elder-table>
  </div>
</div>
